export default {
    type: 'date',
    format: {},
    default: {
        logic: 'min',
        period: 'day'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'rolling'],
        period: ['day', 'week', 'month', 'year']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Date Updated in Collection',
        category: ['User', 'Collection'],
        description: 'When the game was updated in the collection.',
        summarise: {
            prefix: 'Updated in collection'
        },
        unit: function(rule) {

            return rule.setting.period

        }
    }
}